var render = function render(){var _vm=this,_c=_vm._self._c;return _c('step-choice',{attrs:{"tab-class":"tab-age","headline":"Fangen wir an. Wie alt sind Sie?","options":_vm.options},on:{"answer":function($event){return _vm.$emit('answer', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }